// NewCategory.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './NewCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure toastify styles are imported
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const NewPackage = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [Name, setName] = useState('');
    const [nameAr, setnameAr] = useState('');
    const [AdsNumber, setAdsNumber] = useState('');
    const [BoostNumber, setBoostNumber] = useState('');
    const [Duration, setDuration] = useState('');
    const [Price, setPrice] = useState('');
    

    const navigate = useNavigate();



    const handleSave = async (e) => {
        e.preventDefault();
        setError('')
 if ( !Price || !Name || !nameAr ) {
          return  toast.error('Please fill in all required fields.');
        }
        try {
        setLoading(true);

            const token = JSON.parse(localStorage.getItem('token'));
            if (!token) {
                toast.error('You are not authenticated.');
                return;
            }

            const formData = new FormData();
        
            formData.append('name', Name);
            formData.append('name_ar', nameAr);
            formData.append('duration', Duration);
            formData.append('max_ads', AdsNumber);
            formData.append('boosts', BoostNumber);
            formData.append('price', Price);
            const response = await fetch(baseUrl + '/subscription', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: formData,
            });

            const data = await response.json();
            console.log("data", data)
            if (response.ok) {
                toast.success('Package added successfully');
                navigate('/Packages');
            } else {
                if (data.errors) {
                    toast.error(data.errors[0].message);
                }
            }
        } catch (err) {
            console.log("err", err)
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ width: '100%', justifyContent: 'center' }}>
            {loading && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                </div>
            )}


            <h2 style={{ color: "#000", textAlign: 'center' }}>New Package</h2>
            <div className="new-category-container">
                <div className="new-category" style={{ width: "80%", justifyContent: "center", alignContent: "center", alignItems: "center" }}>



                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: Name ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='name'
                            type="text"
                            id="Name"
                            value={Name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>


                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: nameAr ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='name ar'
                            type="text"
                            id="nameAr"
                            value={nameAr}
                            onChange={(e) => setnameAr(e.target.value)}
                            required
                        />
                    </div>

                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: Duration ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='Duration'
                            type="number"
                            id="Duration in days"
                            value={Duration}
                            onChange={(e) => setDuration(e.target.value)}
                            required
                        />
                    </div>


                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: AdsNumber ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='Ads number'
                            type="number"
                            id="Adsnumber"
                            value={AdsNumber}
                            onChange={(e) => setAdsNumber(e.target.value)}
                            required
                        />
                    </div>


                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: BoostNumber ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='Boost Number'
                            type="number"
                            id="Boostnumber"
                            value={BoostNumber}
                            onChange={(e) => setBoostNumber(e.target.value)}
                            required
                        />
                    </div>



                    <div className="new-form-group">
                        <input

                            style={{
                                backgroundColor: "#fff", fontSize: 20, width: "70%",
                                color: Price ? "#000" : "#999"
                                , border: '1px solid rgb(204, 204, 204)', marginBottom: '10px',
                            }}
                            placeholder='Price'
                            type="number"
                            id="Price"
                            value={Price}
                            onChange={(e) => setPrice(e.target.value)}
                            required
                        />
                    </div>



               
                    <div className="form-buttons">
                        <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
                        <button onClick={() => navigate('/Packages')} style={{ backgroundColor: "#000" }}>Cancel</button>
                    </div>

                    <div style={{ height: '50px' }}></div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default NewPackage;
